<!-- Modal content-->
<div class="modal-header navbar-alertia">
    <h4 class="modal-title">{{'general.export' | translate}}</h4>
    <button type="button" title="close" class="close" (click)="activeModal.close(false)">&times;</button>
</div>
<div class="modal-body">
    <ngx-spinner bdColor="rgba(51,51,51,0.55)"
             size="medium"
             color="#fff"
             type="line-spin-clockwise-fade"
             [fullScreen]="false">
        <p class="loading">{{ 'general.loading' | translate }}...</p>
    </ngx-spinner>
    <form class="w-100" [formGroup]="exportLogForm" (ngSubmit)="exportData()" name="form">
        <div class="row text-break"> 
            <div class="col-12">
                <div><p>{{ 'export_optional_date' | translate }}</p></div>
                <div class="row">
                    <div class="col-6">
                            <label for="date" class="page-title mt-1 mr-1 text-dark mb-0">{{'general.date' | translate}}</label><br>
                        <div>
                            <mat-form-field class="mm-10 w-100 fixed-height">
                                <input matInput id="date" formControlName="date" [matDatepicker]="picker" [min]='minDate' [max]='maxDate' readonly
                                [ngClass]="{ 'is-valid': date['valid'], 'is-invalid': date['invalid'] }" >
                                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                <mat-datepicker #picker></mat-datepicker>
                            </mat-form-field>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <hr class="hr-m">
        <div class="row">
            <div class="col-12 text-right">
                <button type="button" title="{{'general.cancel' | translate}}" class="btn btn-red btn-h-red mr-2" (click)="activeModal.close()">
                    {{'general.cancel' | translate}}
                </button>
                <button type="submit" title="{{'general.export' | translate}}" class="btn btn-green btn-h-green">
                    {{'general.export' | translate}}
                </button>
            </div>
        </div>
    </form>
</div>